import {
	WeaLocaleProvider
} from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

export const i18n = {
	module: {
		addressBook: () => getLabel(1515, '通讯录'),
		createResource: () => getLabel(15005, '新建人员'),
		orgChart: () => getLabel(562, '组织图表'),
		trainRecord: () => getLabel('816', "培训记录"),
		resourceChange: () => getLabel('386396', "人员变动情况"),
	},
	label: {
		organization: () => getLabel(25332, '组织结构'),
		allCondition: () => getLabel(382085, '全部条件'),
		toBeSelected: () => getLabel(83302, '待选'),
		selected: () => getLabel(83303, '已选'),
		searchTemplateName: () => getLabel(385087, '搜索模板名称'),
		commonConditions: () => getLabel(32905, '常用条件'),
		pictureSizeSuggestedInfo: () => getLabel(386320, '建议使用的图片大小为:'),
		fillBasicInfo: () => getLabel(386322, '填写基本信息'),
		fillPrivateInfo: () => getLabel(386323, '填写个人信息'),
		fillWorkInfo: () => getLabel(386324, '填写工作信息'),
		fillSysInfo: () => getLabel(386325, '填写系统信息'),
		binding: () => getLabel(28032, '绑定'),
		dataNone: () => getLabel(84304, '暂无'),
		uploadPortrait: () => getLabel(83080, '上传头像'),
		resourceCard: () => getLabel(386343, '人员卡片'),
		fillSpecialtyIntroduction: () => getLabel(386344, '请输入你的专长特点简要介绍'),
		specialtyIntroduction: () => getLabel(383144, '专长介绍'),
		headImagePreview: () => getLabel(386349, '头像预览'),
		role: () => getLabel(24055, '所属角色'),
		editRole: () => getLabel(386351, '编辑所属角色'),
		addRole: () => getLabel(386352, '添加所属角色'),
		securitySetting: () => getLabel(32496, '安全设置'),
		all: () => getLabel(82857, '全部'),
		today: () => getLabel(130019, '今天'),
		yesterday: () => getLabel('82640', "昨天"),
		tswk: () => getLabel(15539, '本周'),
		tsmth: () => getLabel(383428, '本月'),
		tssn: () => getLabel(383465, '本季'),
		tsyr: () => getLabel(130017, '本年'),
		preMonth: () => getLabel(27347, '上个月'),
		preYear: () => getLabel(81716, '上一年'),
		date: () => getLabel(387106, '日期'),
		kqType: () => getLabel(387107, '考勤类型'),
		dateRange: () => getLabel(32530, '指定日期范围'),
		sysManager: () => getLabel(16139, '系统管理员'),
		sysOpLog: () => getLabel(33258, '系统操作日志'),
		tokenNum: () => getLabel(32897, "令牌序列号"),
		userKey: () => getLabel(21597, "用户密钥"),
		autoEnable: () => getLabel(131908, "自动启用"),
		enableDate: () => getLabel(31818, "启用日期"),
		enableMode: () => getLabel(131937, "启用方式"),
		sysInfo: () => getLabel(15804, "系统信息"),
		sysLogiInfo: () => getLabel(130940, "系统登录信息"),
		weekSituation: () => getLabel(130941, "一周情況"),
		ageStatus: () => getLabel('386388', "年龄状况"),
		genderStatus: () => getLabel('386389', "性别状况"),
		workingAgeStatus: () => getLabel('386390', "工龄状况"),
		eduStatus: () => getLabel('386391', "学历状况"),
		maritalStatus: () => getLabel('469', "婚姻状况"),
		proTitleStatus: () => getLabel('386392', "职称统计"),
		rankStatus: () => getLabel('386393', "职级统计"),
		workNature: () => getLabel('804', "用工性质"),
		stateStatistics: () => getLabel('386394', "状态统计"),
		securtitylevel: () => getLabel('683', "安全级别"),
		subordinated: () => getLabel(30805, '的下属'),
		trainingArrangements: () => getLabel('6156', "培训安排"),
		ranking: () => getLabel('19082', "排名"),
		newTypeOfContract: () => getLabel('382214', "新签合同种类"),
		specificInformation: () => getLabel('15729', "具体信息"),
		intoStatistics: () => getLabel('386397', "调入统计"),
		outOfStatistics: () => getLabel('386405', "调出统计"),
		lossStatistics: () => getLabel('386398', "流失统计"),
		turnoverStatistics: () => getLabel('386399', "离职统计"),
		dismissalStatistics: () => getLabel('15978', "解聘统计"),
		retirementStatistics: () => getLabel('16031', "退休统计"),
		newSignStatistics: () => getLabel('386400', "新签统计"),
		expiryStatistics: () => getLabel('386401', "到期统计"),
		newSituation: () => getLabel('16565', "新增情况"),
		correction: () => getLabel('16566', "转正情况"),
		mobility: () => getLabel('16564', "调动情况"),
		renewTheSituation: () => getLabel('16567', "续签情况"),
		returnOnTheSituation: () => getLabel('16568', "返聘情况"),
		lossOfPersonnel: () => getLabel('382249', "人员流失情况"),
		contractSituation: () => getLabel('16572', "合同情况"),
		customerInfo: () => getLabel('17088', "自定义信息"),
		templateName: () => getLabel('28050', "模板名称"),
		ageRange: () => getLabel('15860', "年龄区间"),
		workingAgeRange: () => getLabel('15927', "工龄区间"),
		rankingInterval: () => getLabel('15871', "职级区间"),
		level: () => getLabel('15872', "级"),
		year: () => getLabel('26577', "年"),
		signInDetail: () => getLabel('20241', "签到明细"),
		signOutDetail: () => getLabel('20242', "签退明细"),
		lateDetail: () => getLabel('20088', "迟到明细"),
		absentlateDetail: () => getLabel('383164', "缺勤明细"),
		earlyRetreatDetail: () => getLabel('20089', "早退明细"),
		absenteeismDetail: () => getLabel('20090', "旷工明细"),
		leakageOfSignatureDetail: () => getLabel('20091', "漏签明细"),
		leaveDetail: () => getLabel('20092', "请假明细"),
		businessTripDetail: () => getLabel('20093', "出差明细"),
		publicDetail: () => getLabel('20094', "公出明细"),
		overtimeWorkDetail: () => getLabel('33501', "加班明细"),
		attendanceAnomalyDetail: () => getLabel('386409', "考勤异常数据抵冲明细"),
		reportDate: () => getLabel('20087', "报表生成日期"),
		daytime: () => getLabel(390, '日'),
		day: () => getLabel(1925, '天'),
		hour: () => getLabel('391', "小时"),
		month: () => getLabel(6076, '月'),
		monday: () => getLabel(392, '星期一'),
		tuesday: () => getLabel(393, '星期二'),
		wednesday: () => getLabel(394, '星期三'),
		thursday: () => getLabel(395, '星期四'),
		friday: () => getLabel(396, '星期五'),
		saturday: () => getLabel(397, '星期六'),
		sunday: () => getLabel(398, '星期日'),
		preview: () => getLabel(221, '预览'),
		select: () => getLabel(126832, '选择'),
		'15809': () => getLabel('15809', "已设置"),
		'15808': () => getLabel('15808', "未设置"),
		'26471': () => getLabel('26471', "停用"),
		'388923': () => getLabel('388923', "确定要停用该人员的二次验证密码吗？"),
		'388924': () => getLabel('388924', "为确保账户安全，请及时通知该用户重置密码！"),
		importResult: () => getLabel(82341, '导入结果'),
		styleSettings: () => getLabel(512524,'样式设置'),
	},
	button: {
		collect: () => getLabel(28111, '收藏'),
		log: () => getLabel(83, '日志'),
		helper: () => getLabel(275, '帮助'),
		search: () => getLabel(82529, '搜索'),
		research: () => getLabel('364', "重新搜索"),
		reset: () => getLabel(27088, '重置'),
		ok: () => getLabel(33703, '确定'),
		cancel: () => getLabel(32694, '取消'),
		create: () => getLabel(365, '新建'),
		remove: () => getLabel(20230, '移除'),
		delete: () => getLabel(131966, '删除'),
		modify: () => getLabel(93, '编辑'),
		transfer: () => getLabel(80, '转移'),
		multiRemove: () => getLabel(383696, '批量移除'),
		multiDelete: () => getLabel(32136, '批量删除'),
		save: () => getLabel(30986, '保存'),
		saveAs: () => getLabel(131623, '另存为'),
		done: () => getLabel(555, '完成'),
		saveAsTemplate: () => getLabel(18418, '存为模板'),
		conditionDef: () => getLabel(386317, '常用条件定制'),
		directSubordinates: () => getLabel(386318, '显示直接下属'),
		DisplaySubordinateSubordinates: () => getLabel(83783, '显示下级下属'),
		columnVisibleSetting: () => getLabel(32535, '显示列定制'),
		saveAndCreate: () => getLabel(32720, '保存并新建'),
		fullModle: () => getLabel(386321, '进入完整模式'),
		lastStep: () => getLabel(1876, '上一步'),
		nextStep: () => getLabel(1402, '下一步'),
		back: () => getLabel(1290, '返回'),
		scanAddContacts: () => getLabel(385903, '扫描添加联系人'),
		collapse: () => getLabel(26985, '收起'),
		expand: () => getLabel(15315, '展开'),
		companyWechat: () => getLabel(383148, '微信企业号绑定'),
		putOn: () => getLabel(386345, '贴上'),
		zoomIn: () => getLabel(22209, '缩小'),
		zoomOut: () => getLabel(22208, '放大'),
		clickUpload: () => getLabel(386346, '点击上传'),
		reUpload: () => getLabel(131107, '重新上传'),
		removeHeadImg: () => getLabel(386347, '删除头像'),
		rotate: () => getLabel(386348, '旋转'),
		multiRemove: () => getLabel(383696, '批量移除'),
		multiDelete: () => getLabel(32136, '批量删除'),
		add: () => getLabel(131201, '添加'),
		clickSetting: () => getLabel(386368, '点击设置'),
		more: () => getLabel(131654, '更多'),
		saveAsImage: () => getLabel(385746, '另存为图片'),
		import: () => getLabel(18596, '导入'),
		export: () => getLabel(28343, '导出Excel'),
		export1: () => getLabel(383381, '导出清单到Excel'),
		refresh: () => getLabel(354, '刷新'),
		saveAndSetting: () => getLabel(32159, '保存并进入详细设置'),
		importHistoryQuery: () => getLabel(24644, '历史导入记录'),
		submit: () => getLabel(615, '提交'),
		verification: () => getLabel('15357', "验证"),
		changeValidType: () => getLabel('387341', "更换其他验证方式"),
		resend: () => getLabel('22408', "重新发送"),
		getImportLog: () => getLabel(24835, '导入日志'),
	},
	confirm: {
		defaultTitle: () => getLabel(131329, '信息确认'),
		systemhints: () => getLabel(15172, '系统提示'),
		remove: () => getLabel(83449, '确定要移除吗？'),
		delete: () => getLabel(83877, '确定要删除吗？'),
		removeSelected: () => getLabel(385639, '确定要移除选择的记录吗？'),
		deleteSelected: () => getLabel(385625, '确定要删除选择的记录吗？'),
		delete: () => getLabel(83877, '确定要删除吗？'),
		batchDeleteConfirm: () => getLabel(385625, '确定要删除选择的记录吗？'),
	},
	message: {
		dataConstructError: () => getLabel(385643, '数据格式异常'),
		authFailed: () => getLabel(2012, '对不起，您暂时没有权限！'),
		actionError: () => getLabel(132200, '操作失败！'),
		opSuccess: () => getLabel(384136, '操作成功'),
		saveSuccess: () => getLabel(83551, '保存成功！'),
		saveFailed: () => getLabel(84544, '保存失败！'),
		removeSuccess: () => getLabel(385950, '移除成功！'),
		deleteSuccess: () => getLabel(83472, '删除成功！'),
		dataEmpty: () => getLabel(82241, '不能为空'),
		serverProcessing: () => getLabel(84041, '服务器正在处理，请稍候...'),
		dataNone: () => getLabel(83553, '暂无数据'),
		recordNotFound: () => getLabel(83781, '没有数据'),
		noMatchingData: () => getLabel(384284, '暂无匹配数据'),
		requireFieldNone: () => getLabel(386319, '必填字段不完整！'),
		fillPrivateInfoAlarm: () => getLabel(386326, '个人信息栏目未开放,如有需要请联系管理员开放!'),
		fillWorkInfoAlarm: () => getLabel(386327, '工作信息栏目未开放,如有需要请联系管理员开放!'),
		fillSysInfoAlarm: () => getLabel(386328, '系统信息栏目未开放或者无权限,请联系管理员!'),
		noAvailableCheckoutMethod: () => getLabel(386367, '没有可用的校验方式'),
		noAvailableCheckMode: () => getLabel(386369, '没有可用的校验方式，请点击设置！'),
		fillTelphoneNum: () => getLabel(386370, '请填写手机号！'),
		fillAvailableTelphoneNum: () => getLabel(386371, '请填写正确手机号！'),
		fillUserKey: () => getLabel(386372, '请填写用户密钥'),
		bindToken: () => getLabel(386373, '请绑定令牌序列号！'),
		tokenNumLen: () => getLabel(83745, '令牌序列号必须为10位数字！'),
		tokenBinded: () => getLabel(386374, '令牌序列号已经绑定给{params}，不能重复绑定！'),
		htKey: () => getLabel(83061, '您的浏览器不支持修改使用海泰key的账号密码，请使用IE浏览器'),
		pleaseUploadFile: () => getLabel(384197, '请上传文件'),
		pleaseSelectDelRecord: () => getLabel(387095, '请选择要删除的记录'),
		checkPhoneVCode: () => getLabel('387363', "手机验证码已发送到手机{params}"),
		checkMailVCode: () => getLabel('387364', "随机验证码已发送到邮箱{params}"),
		checkVCode: () => getLabel('125973', "请注意查收！"),
		doubleCheckPwdFaild: () => getLabel(81608, '密码验证不通过，请重新输入！'),
		vCodeExpired: () => getLabel('387398', "验证码已过期"),
		pwdLen: () => getLabel('20172', "密码长度不能小于"),
		pwdType: () => getLabel('512768',"新密码不符合要求，必须包含字母大写、字母小写、数字！请重新输入！"),
		pwdType1: () => getLabel('512769',"新密码不符合要求，必须包含字母、数字、特殊字符！请重新输入！"),
		pwdType2: () => getLabel('512767', "新密码不符合要求，必须包含字母、数字！请重新输入！"),
		selectImportTempleteError: () => getLabel(384059, '导入文件存在以下错误，请解决后重新上传！'),
	},
	smallType: {
		HRM_RSOURCE_CARD: 1, //人员卡片
		HRM_RSOURCE_CARD_BASE: 2, //人员卡片基本信息
		HRM_RSOURCE_CARD_PERSONAL: 3, //人员卡片个人信息
		HRM_RSOURCE_CARD_WORK: 4, //人员卡片工作信息
		HRM_RSOURCE_CARD_SYSTEM: 5, //人员卡片系统信息
		HRM_RSOURCE_CARD_GROUP: 6, //人员卡片常用组
		//HRM_RSOURCE_CARD_ROLE: 7,//人员卡片角色设置
		HRM_RSOURCE_CARD_FINANCE: 16, //人员卡片工资福利
		HRM_RSOURCE_ADD: 8, //新建人员
		HRM_RSOURCE_ADD_BASE: 8, //新建人员基本信息
		HRM_RSOURCE_ADD_PERSONAL: 10, //新建人员个人信息
		HRM_RSOURCE_ADD_WORK: 11, //新建人员工作信息
		HRM_RSOURCE_ADD_SYSTEM: 12, //新建人员系统信息
		HRM_PASSWPRD: 13, //密码设置
		HRM_RSOURCEMANAGER: 14, //管理员
		HRM_RSOURCEMANAGER_SECURITYSETTING: 15, //管理员卡片安全设置
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/i18n.js